// src/services/ApiService.js

import axios from "axios";

export const initialAuthState = {
  userId: 4,
  userName: "admin",
  companyCode: "WAY4TRACK",
  unitCode: "WAY4",
};

const ApiService = (() => {

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    // baseURL: 'https://sharontelematics.org/api/',
    withCredentials: true,
  });

  // const axiosInstance = axios.create({
  //   baseURL: process.env.REACT_APP_API_STAGING_BASE_URL,
  //   withCredentials: true,
  // });

  // const axiosInstance = axios.create({
  //   baseURL: isLocalhost
  //     ? process.env.REACT_APP_LOCAL_API_BASE_URL
  //     : process.env.REACT_APP_API_BASE_URL,
  //   withCredentials: true,
  //   // timeout: 10000000, // Request timeout in milliseconds
  // });

  // Interceptor for handling requests
  axiosInstance.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data"; // Set for FormData
    } else {
      config.headers["Content-Type"] = "application/json"; // Default
    }
    return config;
  });

  // Interceptor for handling responses
  // axiosInstance.interceptors.response.use(
  //   (response) => response.data,
  //   (error) => {
  //     console.error(
  //       "API error:",
  //       error.response ? error.response.data : error.message
  //     );
  //     return Promise.reject(error.response || error.message);
  //   }
  // );

  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve();
      }
    });
    failedQueue = [];
  };

  axiosInstance.interceptors.response.use(
    (response) => response.data,
    async (error) => {
      const originalRequest = error.config;

      console.error(
        "API error:",
        error.response ? error.response.data : error.message
      );

      if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        !originalRequest.url.includes("/auth/me") &&
        !originalRequest.url.includes("/auth/refresh")
      ) {

        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then(() => axiosInstance(originalRequest));
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          await axiosInstance.post("/auth/refresh");

          processQueue(null);
          return axiosInstance(originalRequest);

        } catch (refreshError) {
          processQueue(refreshError);
          window.location.href = "/login";
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error.response || error.message);
    }
  );

  return {
    get: (url, params) => axiosInstance.get(url, { params }),
    post: (url, data) => axiosInstance.post(url, data),
    put: (url, data) => axiosInstance.put(url, data),
    delete: (url) => axiosInstance.delete(url),
  };
})();

export default ApiService;
